var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"collapse",class:{
        'collapse--is-active': _vm.isActive,
        'collapse--is-animating': _vm.isAnimating,
    },style:(_vm.style),on:{"transitionend":_vm.onTransitionEnd}},[_vm._t("default")],2)}
var staticRenderFns = []

export { render, staticRenderFns }